import React, { useState, useEffect } from "react";
import styles from "../../../../styles/PaymentNew.module.css";
import BlackLeftArrow from "../../../../assets/images/black_left_arrow.svg";
import { useHistory } from "react-router";
import { AxiosInstance, PORTS } from "../../../../utils/apiService";
import { notification, Select } from "antd";
import { useParams } from "react-router-dom";
import ButtonComponent from "../../../modules/ReusableComponent/ButtonComponent";
import InputComponent from "../../../modules/ReusableComponent/InputComponent";
import FormErrorText from "../../../modules/ProductManagement/FormErrorText";
import LoadingIndicator from "../../../modules/ReusableComponent/LoadingIndicator";
import {
  addressRegx,
  alphaNum,
  noSpace,
  alphaNumwithSpace,
  alphanumericwithdashHyphen,
  minChar,
  userNameWithSpace,
  minCharWithNoMaxLimit,
} from "../../../../utils/RegularExp";
import commonstyles from "../../../../styles/Management_Common.module.css";
import { runValidationChecks } from "../../../../utils";
import { isObject, isString, isEqual } from "lodash";

import moment from "moment";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {MAIN_SITE} from "../../../../utils/apiService"

const { Option } = Select;
const initialFormState = {
  _id: "",
  title: "",
  slug: "",
  headerContent: "",
  footerContent: "",
  categoryId: [],
  regionId: "",
  metaTitle: "",
  metaDescription: "",
  metaKeywords: "",
  enable: true,
};

export default function LandingCategoryComponent() {
  const rules = {
    title: [(val, data) => (!val ? "Title " : true)],
    slug: [(val, data) => (!val && !categoryDetail.slug ? "Slug " : true)],
    category: [
      (val, data) => (data.categoryId.length > 0 ? true : "Category "),
    ],
    regionId: [(val, data) => (data.regionId ? true : "Region ")],
    headerContent: [(val, data) => (!val ? "Header content " : true)],
    footerContent: [(val, data) => (!val ? "Footer content " : true)],
    metaTitle: [
      (val, data) => (!val && !categoryDetail.metaTitle ? "Meta title " : true),
    ],
    metaKeywords: [
      (val, data) =>
        !val && !categoryDetail.metaKeywords ? "Meta keywords " : true,
    ],
    metaDescription: [
      (val, data) =>
        !val && !categoryDetail.metaDescription ? "Meta description " : true,
    ],
  };
  const history = useHistory();

  const { state } = history.location;

  // const { id } = history?.location?.state ? history?.location?.state : "";
  // const [loading, setLoading] = useState({ details: false, update: false });
  const [page, setPage] = useState(state);
  const [id,setId] = useState(state?.id ? state.id : undefined )
  const [isLoading, setIsLoading] = useState(true);
  const [regions, setRegions] = useState([]);
  const [regionId, setRegionId] = useState("");
  // const { state } = history.location;
  // const [page, setPage] = useState(state);
  const [bannerDetail, setBannerDetail] = useState([]);
  const [topContent, setTopContent] = useState("");
  const [editForm, setEditForm] = useState(
    JSON.parse(JSON.stringify(initialFormState))
  );
  const [category, setCategory] = useState("");
  const [parentCategories, setParentCategories] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [categoryDetail, setCategoryDetail] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [link, setLink] = useState("");

  const globalLinkToMainSite = `${MAIN_SITE}/productLanding/${categoryDetail.slug}-${link}`;
 
  function getParentCategories() {
    AxiosInstance(PORTS.CATALOG_SERVICE, "application/json")
      .get("/admin/catalog/getCategoryName")
      .then((res) => {
        if (res.status === 200 && res.data.status === 200) {
          setParentCategories(res.data.daaata);
          // setIsLoading(false);
        }
      })
      .catch((er) => {
        console.error("Failed to fetch parent categories");
      });
  }

  useEffect(() => {
    // setFormErrors({});
    if(!id && history.location.pathname.split("/")[3].match(/^[0-9a-fA-F]{24}$/)){
      setId(history.location.pathname.split("/")[3])
    }
    setPage(state ? state : 5);
    getParentCategories();
    getRegionList();
    
    return () => {
      history["isProduct"] = true;
    };
  }, []);

  function getRegionList() {
    AxiosInstance(PORTS.REGION_SERVICE, "application/json")
      .get("admin/region/getRegionList")
      .then((res) => {
        if (res.status === 200 && res.data.status === 200) {
          setRegions(res.data.daaata);
          if (res.data.daaata[0]) {
            setRegionId(res.data.daaata[0]?._id);
          }
          getLandingList(res.data.daaata);
            setLink("All Region")
            
        }
      })
      .catch((er) => {
        // console.log(er);
        return er;
      });
  }

  function getLandingList(regions) {
    setIsLoading(true);
    AxiosInstance(PORTS.CMS, "application/json")
      .get(`/productPage/${id}`)
      .then((res) => {
        if (res.status === 200 && res.data.status === 200) {
          const val =
            res.data.data[0] || JSON.parse(JSON.stringify(initialFormState));
          // console.log(val);
          // setEditForm({});
          // console.log(initialFormState);
          // setLink(editForm.)
          

          setTopContent(val.headerContent);
          setEditForm(val);
          if(regions){
            regions.map(
              (region) =>
                region._id == val.regionId && setLink(region.name)
            );
          }
         
          AxiosInstance(PORTS.CATALOG_SERVICE, "application/json")
            .get(
              `/admin/catalog/categoryDetails/${res.data.data[0].categoryId}`
            )
            .then((res) => {
              if (res.status === 200 && res.data.status === 200) {
                setCategoryDetail(res.data.data);
                // loadImages(res.data.data);
              }
            })

            .catch((er) => {
              return er;
            })
            .finally(() => {
              setIsLoading(false);
            });
            setIsLoading(false);
        }
      })
      .catch((er) => {
        return er;
      });
  }

  function showNotification({ type, message, description }) {
    let options = {
      message: message || "Message",
      description: description,
      duration: 5,
    };
    notification[type](options);
  }

  function handleInputSlug(event) {
    var k = event ? event.which : window.event.keyCode;
    if (k === 32) {
      return false;
    } else {
      if (!alphanumericwithdashHyphen.test(event.target.value)) {
        formErrors.slug = "Enter only alphabet and number";
      }
      setEditForm({
        ...editForm,
        slug: event.target.value.toLowerCase().split(" ").join(""),
      });
    }
  }

  // *** INPUT HANDLE CHANGE *** //
  function handleFormInput(e) {
    let { name, value, checked, innerText } = e.target;

    if (name === "metaDescription" && !minChar.test(e.target.value)) {
      if (!formErrors.metaDescription) {
        formErrors.metaDescription = {};
      }
      formErrors.metaDescription = "Enter minimum 3 characters";
    } else {
      if (formErrors.metaDescription) {
        formErrors.metaDescription = "";
      }
    }
    if (["regionId"].includes(name)) {
      formErrors.regionId = "";
      setLink(e.target.options[e.target.selectedIndex].text);
      console.log("name");
      // setRegionLink();
    }
    if (["title"].includes(name)) {
      if (noSpace.test(value)) {
        formErrors.title = "Enter only alphabet and number";
      }
      setEditForm({ ...editForm, [name]: value });
    }

    if (["metaTitle"].includes(name)) {
      // if (noSpace.test(value)) {
      //   formErrors.metaTitle = "Enter only alphabet and number";
      // }
      
      setEditForm({ ...editForm, [name]: value });
    }

    if (["metaKeywords"].includes(name)) {
      // if (noSpace.test(value)) {
      //   formErrors.metaKeywords = "Enter only alphabet and number";
      // }
      setEditForm({ ...editForm, [name]: value });
    }

    if (["metaDescription"].includes(name)) {
      // if (noSpace.test(value)) {
      //   formErrors.metaDescription = "Enter only alphabet and number";
      // }
      
      setEditForm({ ...editForm, [name]: value });
    }
    
    // console.log(formErrors);

    const updatedValues = { ...editForm, [name]: value };

    if (["enable"].includes(name)) {
      updatedValues[name] = checked;
    } else {
      updatedValues[name] = value;
    }
    setEditForm(updatedValues);
  }

  function handleCategory(e) {
    if (e.length == "") {
      formErrors.category = "Category";
    } else {
      formErrors.category = "";
    }
    AxiosInstance(PORTS.CATALOG_SERVICE, "application/json")
      .get(`/admin/catalog/categoryDetails/${e}`)
      .then((res) => {
        if (res.status === 200 && res.data.status === 200) {
          setCategoryDetail(res.data.data);
          // loadImages(res.data.data);
        }
      })

      .catch((er) => {
        return er;
      })
      .finally(() => {
        setIsLoading(false);
      });
    editForm.categoryId = e;
    setCategory({ ...editForm });
  }

  // *** SAVE CHANGES *** //
  function submit() {
    let data = JSON.parse(JSON.stringify(editForm));
    // data.slug = data.slug.trim();
    // data.regionId = regionId ? regionId : "";

    data.slug = `${categoryDetail.slug}-${link}`;
    data.metaTitle = data.metaTitle ? data.metaTitle : categoryDetail.metaTitle;
    data.metaKeywords = data.metaKeywords
      ? data.metaKeywords
      : categoryDetail.metaKeywords;
    data.metaDescription = data.metaDescription
      ? data.metaDescription
      : categoryDetail.metaDescription;
    delete data.userName;
    delete data.updatedAt;
    const result = runValidationChecks(rules, undefined, { ...data });

    // console.log(result);
    if (Object.keys(result).length > 0) {
      setFormErrors(result);
      showNotification({
        type: "warning",
        message: "There were few errors",
        description: Object.values(result) + "is required",
      });
      return;
    }

    if (noSpace.test(editForm.title)) {
      showNotification({
        type: "warning",
        message: "There were few errors",
        description: "Enter only alphabet and number for title",
      });
      return;
    }

    let edit = "/productPage/updatePage";
    let add = "/productPage/createPage";

    // console.log(id);
    if (id == undefined) {
      delete data._id;
    }

    AxiosInstance(PORTS.CMS, "application/json")
      //   .post(`/landingPage/${state?._id ? "updatePage" : "addPage"}/`, data)
      .post(id ? edit : add, data)
      .then((res) => {
        // console.log(res.data);
        if (res.data.status === 200) {
          // setIsLoading(false);
          getLandingList();
          showNotification({
            type: "success",
            message: "Success",
            description: id
              ? "Product wise landing page updated successfully "
              : "Product wise landing page added successfully ",
          });
          history.push("/Content");
        } else {
          showNotification({
            type: "error",
            message: "Error",
            description: res?.data?.msg,
          });
        }
      })
      .catch((er) => {
        // console.log(er);
        return er;
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append("files", file);
            AxiosInstance(PORTS.CATALOG_SERVICE, "application/json")
              .post(`/admin/uploadImages`, body)
              .then((res) => {
                if (res.data.status === 200) {
                  resolve({
                    default: `${res.data?.data[0]?.link}`,
                  });
                } else if (res.data.status === 400) {
                  showNotification({
                    type: "error",
                    message: "Adding CMS failed",
                    description: res.data?.msg || "Error occured",
                  });
                }
              })
              .catch((er) => {
                showNotification({
                  type: "error",
                  message: "Adding CMS failed",
                  description: "Error occured",
                });
              })
              .finally(() => {
                setIsLoading(false);
              });
          });
        });
      },
    };
  }

  return (
    <div className={styles.management_contents}>
      <div className={styles.management_header}>
        <h1>
          <img
            src={BlackLeftArrow}
            alt=""
            className="cursor-pointer"
            onClick={() => history.push("/Content")}
          />
          Product-Wise Landing Page Management
        </h1>
      </div>
      {isLoading === true && id ? (
        <div
          style={{
            marginLeft: "50vh",
            marginTop: "10vh",
          }}
        >
          <tr className="bg-transparent">
            <td colSpan="100%">
              <LoadingIndicator loadingText="Fetching product wise landing page details..." />
            </td>
          </tr>
        </div>
      ) : (
        <div>
          <div className={`${styles.banner_citys_update}`}>
            {editForm?.userName && (
              <p style={{ textTransform: "capitalize" }}>
                Last updated by: <span>{editForm?.userName}</span>
              </p>
            )}
            {editForm?.updatedAt && (
              <p>
                Last updated on:{" "}
                <span>
                  {moment(editForm?.updatedAt).format("DD/MM/YYYY | hh:mm A")}
                </span>
              </p>
            )}
          </div>
          <div
            className={`${styles.management_header} ${styles.banner_city_list}`}
          >
            <div className={`${styles.banner_citys} landing_select_city `}>
              <span
                className="text-danger product_wise_text-danger"
                style={{ fontSize: "20px" }}
              >
                *
              </span>
              <div className="d-flex flex-column error_msg_right">
                <Select
                  className={"form-control " + styles.form_control}
                  // onChange={(e) => setRegion(e.target.value)}
                  // value={region}
                  // mode="multiple"
                  disabled={id ? true : false}
                  error={formErrors.category}
                  placeholder="Select category"
                  name="category"
                  value={editForm.categoryId}
                  onChange={(e) => handleCategory(e)}
                  style={{ cursor: "pointer" }}
                >
                  {parentCategories.map((category) => (
                    <>
                      <option value={category._id} label={category.name}>
                        {category.name}
                      </option>
                    </>
                  ))}
                </Select>
                <FormErrorText error={formErrors.category} />
              </div>
              <span
                className="text-danger product_wise_text-danger"
                style={{ fontSize: "20px" }}
              >
                *
              </span>
              <div className="d-flex flex-column region_selector">
                <select
                  className={"" + styles.form_control}
                  error={formErrors.regionId}
                  name="regionId"
                  value={editForm.regionId}
                  onChange={handleFormInput}
                  style={{ cursor: "pointer" }}
                  disabled={id ? true : false}
                >
                  <option value="">Select Region</option>
                  {regions.map((region) => (
                    <>
                      <option value={region._id} label={region.name}>
                        {region.name}
                      </option>
                    </>
                  ))}
                </select>
                <FormErrorText error={formErrors.regionId} />
              </div>
            </div>

            <div className={styles.management_contents_upload}>
              <div className={`${styles.onoffswitch} d-inline-block align-top`}>
                <input
                  type="checkbox"
                  name="enable"
                  className={styles.onoffswitch_checkbox}
                  onChange={handleFormInput}
                  checked={editForm?.enable}
                  id="statusSwitch"
                />
                <label
                  className={styles.onoffswitch_label}
                  htmlFor="statusSwitch"
                >
                  <span className={styles.onoffswitch_inner}></span>
                  <span className={styles.onoffswitch_switch}></span>
                </label>
              </div>
              <ButtonComponent
                className="rnd mr-3 outline_cancel_btn"
                attributes={{
                  onClick: () => history.push(`/Content`),
                }}
              >
                Cancel
              </ButtonComponent>
              <ButtonComponent
                className="rnd"
                attributes={{
                  // disabled: loading.update,
                  onClick: submit,
                }}
              >
                Save
              </ButtonComponent>
            </div>
          </div>

          <div
            className={`${styles.management_details} ${styles.landing_category_management}`}
          >
            <div
              /* key={indx} */ className={styles.management_details_contents}
            >
              <div className="row">
                <div className="col-lg-6 mb-4">
                  <div className={styles.management_details_form}>
                    <label for="">
                      Page title
                      <span
                        className="text-danger"
                        style={{ fontSize: "20px" }}
                      >
                        *
                      </span>
                    </label>
                    <InputComponent
                      className={`form-control form-control-lg ${styles.form_control}`}
                      error={formErrors.title}
                      formControl={{
                        placeholder: "",
                        name: "title",
                        value: categoryDetail?.title || editForm?.title,
                        onChange: (e) => {
                          if (!minChar.test(e.target.value)) {
                            if (!formErrors.title) {
                              formErrors.title = {};
                            }
                            formErrors.title = "Enter minimum 3 characters";
                          } else {
                            if (formErrors.title) {
                              formErrors.title = "";
                            }
                          }

                          handleFormInput(e);
                        },
                      }}
                    />
                    <FormErrorText error={formErrors.title} />
                  </div>
                </div>
                {/* Slug */}
                <div className="col-lg-6 mb-4 slug_input_white_bg">
                  <label className={commonstyles.secondry_title}>
                    Slug
                    <span className="text-danger" style={{ fontSize: "20px" }}>
                      *
                    </span>
                    <a href={globalLinkToMainSite} target="_blank">
                      {categoryDetail.slug && link && globalLinkToMainSite}
                    </a>
                  </label>
                  <InputComponent
                    error={formErrors.slug}
                    className="form-control-lg"
                    formControl={{
                      placeholder: "Type slug",
                      name: "slug",
                      value: `${categoryDetail?.slug ? categoryDetail?.slug : ""}-${link}`,
                      // onChange: (e) => {
                      //   if (!minChar.test(e.target.value)) {
                      //     if (!formErrors.slug) {
                      //       formErrors.slug = {};
                      //     }
                      //     formErrors.slug = "Enter minimum 3 characters";
                      //   } else {
                      //     if (formErrors.slug) {
                      //       formErrors.slug = "";
                      //     }
                      //   }
                      //   handleInputSlug(e);
                      // },
                      disabled: true,
                    }}
                  />
                  <FormErrorText error={formErrors.slug} />
                </div>
                {/* Slug ends */}
                <div className="col-lg-12 mb-4">
                  <div className={styles.management_details_form}>
                    <label for="">
                      Top Content
                      <span
                        className="text-danger"
                        style={{ fontSize: "20px" }}
                      >
                        *
                      </span>
                    </label>

                    {/* {page?._id && editForm.content && ( */}
                    <CKEditor
                      error={formErrors.headerContent}
                      editor={ClassicEditor}
                      data={categoryDetail?.topContent || topContent || ""}
                      config={{ extraPlugins: [uploadPlugin] }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        const values = { ...editForm };
                        // console.log(values);
                        values.headerContent = data;
                        if (!minCharWithNoMaxLimit.test(data)) {
                          if (!formErrors.headerContent) {
                            formErrors.headerContent = {};
                          }
                          formErrors.headerContent = "Header content required";
                        } else {
                          if (formErrors.headerContent) {
                            formErrors.headerContent = "";
                          }
                        }
                        setEditForm(values);
                      }}
                    />
                    {/* )} */}
                    {/*  {!(page?._id && editForm.content) && (
                                        <CKEditor
                                        editor={ ClassicEditor }
                                        data={editForm?.content || ""}
                                        onChange={ ( event, editor ) => {
                                            const data = editor.getData();
                                            const values = editForm;
                                            values.content = data;
                                            setEditForm(values);
                                        } }
                                    />
                                    )} */}

                    <FormErrorText error={formErrors.headerContent} />
                  </div>
                </div>
                <div className="col-lg-12 mb-4">
                  <div className={styles.management_details_form}>
                    <label for="">
                      Bottom Content
                      <span
                        className="text-danger"
                        style={{ fontSize: "20px" }}
                      >
                        *
                      </span>
                    </label>
                    <CKEditor
                      error={formErrors.footerContent}
                      editor={ClassicEditor}
                      data={
                        categoryDetail?.footerContent ||
                        editForm?.footerContent ||
                        ""
                      }
                      config={{ extraPlugins: [uploadPlugin] }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        const values = { ...editForm };
                        // console.log(data);
                        // console.log(values);
                        values.footerContent = data;
                        if (!minCharWithNoMaxLimit.test(data)) {
                          if (!formErrors.footerContent) {
                            formErrors.footerContent = {};
                          }
                          formErrors.footerContent = "Footer content required";
                        } else {
                          if (formErrors.footerContent) {
                            formErrors.footerContent = "";
                          }
                        }
                        setEditForm(values);
                      }}
                    />
                    <FormErrorText error={formErrors.footerContent} />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.management_details_contents}>
              <h4 className="theme-form-section-title">
                Search Engine Optimization
              </h4>
              <div className="row">
                {/* <div className="col-lg-6 mb-4">
                            <div className={styles.management_details_form}>
                            <label for="">URL Key</label>
                            <InputComponent
                                className={`form-control form-control-lg ${styles.form_control}`}
                                // error={formErrors.urlkey}
                                formControl={{
                                placeholder: "",
                                name: "urlkey",
                                value: editForm?.urlkey,
                                onChange:handleFormInput,
                                }}
                            />
                            // <FormErrorText error={formErrors.urlkey} />
                            </div>
                        </div> */}
                <div className="col-lg-6 mb-4">
                  <div className={styles.management_details_form}>
                    <label for="">
                      Meta Title
                      <span
                        className="text-danger"
                        style={{ fontSize: "20px" }}
                      >
                        *
                      </span>
                    </label>
                    <InputComponent
                      className={`form-control form-control-lg ${styles.form_control}`}
                      error={formErrors.metaTitle}
                      formControl={{
                        placeholder: "",
                        disabled: id || categoryDetail.metaTitle ? true : false,
                        name: "metaTitle",
                        value: categoryDetail?.metaTitle || editForm?.metaTitle,
                        onChange: (e) => {
                          // if (!minChar.test(e.target.value)) {
                          //   if (!formErrors.metaTitle) {
                          //     formErrors.metaTitle = {};
                          //   }
                          //   formErrors.metaTitle = "Enter minimum 3 characters";
                          // } else {
                          //   if (formErrors.metaTitle) {
                          //     formErrors.metaTitle = "";
                          //   }
                          // }
                          handleFormInput(e);
                        },
                      }}
                    />
                    <FormErrorText error={formErrors.metaTitle} />
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className={styles.management_details_form}>
                    <label for="">
                      Meta Keywords
                      <span
                        className="text-danger"
                        style={{ fontSize: "20px" }}
                      >
                        *
                      </span>
                    </label>
                    <InputComponent
                      className={`form-control form-control-lg ${styles.form_control}`}
                      error={formErrors.metaKeywords}
                      formControl={{
                        disabled:
                          id || categoryDetail.metaKeywords ? true : false,
                        placeholder: "",
                        name: "metaKeywords",
                        value:
                          categoryDetail?.metaKeywords ||
                          editForm?.metaKeywords,
                        onChange: (e) => {
                          if (!minChar.test(e.target.value)) {
                            if (!formErrors.metaKeywords) {
                              formErrors.metaKeywords = {};
                            }
                            formErrors.metaKeywords =
                              "Enter minimum 3 characters";
                          } else {
                            if (formErrors.metaKeywords) {
                              formErrors.metaKeywords = "";
                            }
                          }
                          handleFormInput(e);
                        },
                      }}
                    />
                    <FormErrorText error={formErrors.metaKeywords} />
                  </div>
                </div>
                <div className="col-lg-12 mb-4">
                  <div className={styles.management_details_form}>
                    <label for="">
                      Meta Description
                      <span
                        className="text-danger"
                        style={{ fontSize: "20px" }}
                      >
                        *
                      </span>
                    </label>
                    <textarea
                      className={`form-control form-control-lg ${styles.form_control}`}
                      error={formErrors.metaDescription}
                      // formControl={{
                      placeholder=""
                      name="metaDescription"
                      disabled={
                        id || categoryDetail.metaDescription ? true : false
                      }
                      value={
                        categoryDetail?.metaDescription ||
                        editForm?.metaDescription
                      }
                      onChange={(e) => handleFormInput(e)}
                    />
                    <FormErrorText error={formErrors.metaDescription} />
                  </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      )}
      {/* )} */}
    </div>
  );
}
